import MaterialTable from "@material-table/core";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { Globals } from "../../../helpers/globals";
import Footer from "../../../components/shared/Footer";
import * as Cols from "../MatterManagmentColumns";
import { MatterService } from "../../../services/ClientService";
import * as APIModels from "../../../models";
import { FileService } from "../../../services/SubmissionService";
import TemplateCard from "./TemplateCard";
import DatabaseCard from "../DatabaseCard";
import TemplateCreateModal from "./TemplateCreateModal";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Stack,
    Table,
    TableBody,
    TableHead,
    Card,
    TableRow,
} from "@mui/material";
import { TableCell } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { Download } from "@mui/icons-material";
import AppBar from "../AppBar";

const useKeyPress = (targetKey: string) => {
    const [keyPressed, setKeyPressed] = useState(false);

    useEffect(() => {
        const handleKeyPress = (event: KeyboardEvent) => {
            if (event.key === targetKey && event.ctrlKey) {
                setKeyPressed(true);
            }
        };

        document.addEventListener("keypress", handleKeyPress);

        return () => {
            document.removeEventListener("keypress", handleKeyPress);
        };
    }, [targetKey]);

    return keyPressed;
};

export default function MergeMatterPage() {
    function handleKeyPress(event: KeyboardEvent) {
        if (event.key === "e" && event.ctrlKey) {
            event.preventDefault();
            setExpanded(!expanded);
        }
    }
    const f: APIModels.FileInfo[] = [];
    const [files, setFiles] = useState(f);
    const [expanded, setExpanded] = useState<boolean>(true);
    const [expandedDatabaseCard, setExpandedDatabaseCard] =
        useState<boolean>(true);

    /**  */
    const [templateCreateModalIsOpen, setTemplateCreateMadalIsOpen] =
        useState<boolean>(false);

    /* these ore for the new component eventually */
    const [merged, setMerged] = useState(f);
    /* -------------------------------------------*/

    const currentUser = Globals.currentUserValue;
    const { matterId } = useParams<{ matterId?: string }>();
    const [matter, setMatter] = useState<APIModels.MatterResponse>(
        {} as APIModels.MatterResponse
    );
    const [mergeFields, setMergeFields] = useState<{ [key: string]: string }>(
        {}
    );
    const [logs, setLogs] = useState<Array<APIModels.MatterLogResponse>>([]);
    const keyPressed = useKeyPress("e");
    console.log({
        location: "/matter/merge/index.tsx",
        currentUser: { ...currentUser },
    });

    useEffect(() => {
        FileService.list({
            route: "merged",
        }).then(
            (resp) => {
                if (resp.successful === true && resp.data) {
                    const r = resp.data.filter((d) => {
                        if (d.filename !== "") return d;
                    });
                    console.log(r);

                    setMerged(r);
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }, []);

    const refreshMerged = () => {
        FileService.list({
            route: "merged",
        }).then(
            (resp) => {
                if (resp.successful === true && resp.data) {
                    const r = resp.data.filter((d) => {
                        if (d.filename !== "") return d;
                    });
                    console.log(r);

                    setMerged(r);
                }
            },
            (error) => {
                console.error(error);
            }
        );
    };

    useEffect(() => {
        MatterService.getV2({
            matterId: matterId ?? APIModels.EmptyGuid,
        }).then((res) => {
            if (res.data && res.successful) {
                setMatter(res.data);
                const obj = res.data.mergeFields as { [key: string]: string };
                console.log({ object: { ...obj } });
                setMergeFields(obj);
            } else {
                console.error(res.errorMessage);
            }
        });
    }, [matterId]);

    const onDownload = (file: APIModels.FileInfo) => {
        FileService.get({
            submissionId: currentUser.id + "/merged",
            documentId: file.filename ?? "",
            source: "upload",
        })
            .then((resp) => resp.json())
            .then((data) => {
                const downloadUrl = data.url;
                window.open(downloadUrl, "_blank");
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        if (keyPressed) {
            setExpanded(!expanded);
        }
    }, [keyPressed]);

    const merge = (request: { body?: APIModels.MergeRequest }) => {
        MatterService.merge(request).then((res) => {
            if (res.data && res.successful) {
                refreshMerged();
                setLogs(res.data);
            }
        });
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <Stack direction="column" spacing={4} marginTop={4}>
                    <AppBar
                        sx={{ width: "100%", paddingY: 1, paddingX: 2 }}
                        buttonSpacing={6}
                        iconSpacing={6}
                    />
                    <Accordion
                        sx={{ paddingX: "12px" }}
                        expanded={expanded}
                        TransitionProps={{ timeout: 300 }}
                        onClick={() => {
                            setExpanded(!expanded);
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <h6>Merge Fields</h6>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Merge Field</TableCell>
                                        <TableCell> </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.entries(mergeFields).map(
                                        ([key, value]) => (
                                            <TableRow key={key}>
                                                <TableCell>{key}</TableCell>
                                                <TableCell>{value}</TableCell>
                                            </TableRow>
                                        )
                                    )}
                                </TableBody>
                            </Table>
                        </AccordionDetails>
                    </Accordion>
                    <DatabaseCard
                        statuses={logs}
                        title="View Merge Logs"
                        expand={expandedDatabaseCard}
                        setExpanded={setExpandedDatabaseCard}
                    />
                    <TemplateCreateModal
                        userId={currentUser.userID ?? APIModels.EmptyGuid}
                        organizationId={
                            currentUser.organizationID ?? APIModels.EmptyGuid
                        }
                        isOpen={templateCreateModalIsOpen}
                        handleClose={() => setTemplateCreateMadalIsOpen(false)}
                    />
                    <TemplateCard
                        matterId={matterId ?? APIModels.EmptyGuid}
                        userId={currentUser.id ?? APIModels.EmptyGuid}
                        organizationId={
                            currentUser.organizationID ?? APIModels.EmptyGuid
                        }
                        merge={merge}
                        refreshMerged={refreshMerged}
                    />
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    <MaterialTable
                                        columns={Cols.MergedTemplateColumns}
                                        data={merged}
                                        title="Merged Templates"
                                        actions={[
                                            {
                                                icon: () => <Download />,
                                                tooltip:
                                                    "Download Merged Template",
                                                onClick: (event, rowData) => {
                                                    const row =
                                                        rowData as APIModels.FileInfo;
                                                    onDownload(row);
                                                },
                                            },
                                        ]}
                                        options={{
                                            actionsColumnIndex: -1,
                                            pageSizeOptions: [
                                                5, 10, 20, 50, 75, 100,
                                            ],
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Stack>
            </div>
            <div className="row">
                <div className="col-6">
                    <a
                        className="btn btn-success btn-large"
                        href="/matter/management"
                    >
                        Finish
                    </a>
                </div>
            </div>
        </div>
    );
}
